import { SelectNew } from "antd";
import WeaRangePicker from "../wea-range-picker";
import isEmpty from "lodash/isEmpty";
const Option = SelectNew.Option;

class WeaDateGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectValue: "",
      rangeValue: []
    };
    if (!isEmpty(props.value)) {
      this.state.selectValue = props.value[0];
      if (props.value[0] == "6") {
        // this.setState({ rangeValue: [props.value[1], props.value[2]] });
        this.state.rangeValue = [props.value[1], props.value[2]];
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps) {
      let selectValue = "0";
      let rangeValue = [];
      if (!isEmpty(nextProps.value)) {
        selectValue = nextProps.value[0];
        if (nextProps.value[0] == "6") {
          rangeValue = [nextProps.value[1], nextProps.value[2]];
        }
      }
      this.setState({
        selectValue,
        rangeValue
      });
    }
  }
  isDisabledDate = (yearOne, monthOne, dayOne, yearTwo, monthTwo, dayTwo) => {
    let bool = false;
    if (yearTwo > yearOne) bool = true;
    else if (yearTwo === yearOne) {
      if (monthTwo > monthOne) bool = true;
      else if (monthTwo === monthOne) {
        if (dayTwo > dayOne) bool = true;
      }
    }
    return bool;
  };
  getDisabledDate = (current, value, isStartValue = false) => {
    let bool = false;
    if (current && value) {
      const currentYear = current.getYear();
      const currentMonth = current.getMonth() + 1;
      const currentDay = current.getDayOfMonth();
      const year = new Date(value).getFullYear();
      const month = new Date(value).getMonth() + 1;
      const day = new Date(value).getDate();
      if (isStartValue) {
        bool = this.isDisabledDate(
          currentYear,
          currentMonth,
          currentDay,
          year,
          month,
          day
        );
      } else {
        bool = this.isDisabledDate(
          year,
          month,
          day,
          currentYear,
          currentMonth,
          currentDay
        );
      }
    }
    return bool;
  };
  render() {
    const {
      datas,
      viewAttr,
      textDecoration,
      className = "",
      isInline,
      style
    } = this.props;
    const { selectValue, rangeValue } = this.state;
    let disabled = false;
    if (viewAttr == "1") disabled = true;
    return (
      <div
        className={`wea-date-group ${className} ${isInline ? "isInline" : ""}`}
        style={style}
      >
        <SelectNew
          value={selectValue}
          disabled={disabled}
          size={"default"}
          className={`wea-date-group-select ${textDecoration &&
            "text-decoration"}`}
          onChange={v => {
            let rangeValue = this.state.rangeValue;
            if (v != "6") {
              rangeValue = [];
            }
            this.setState({ selectValue: v, rangeValue });
            this.props.onChange && this.props.onChange([v, ...rangeValue]);
          }}
        >
          {datas &&
            datas.map(d => {
              return (
                <Option value={d.value} title={d.name}>
                  {d.name}
                </Option>
              );
            })}
        </SelectNew>
        {selectValue === "6" && ( // 指定日期范围更换为WeaRangePicker组件
          <div className="wea-date-group-rangePicker">
            <WeaRangePicker
              value={rangeValue}
              viewAttr={viewAttr}
              textDecoration={textDecoration}
              onChange={v => {
                this.setState({ rangeValue: v });
                this.props.onChange && this.props.onChange([selectValue, ...v]);
              }}
            />
          </div>
        )}
        {/* {selectValue === "6" && (
          <DatePicker
            textDecoration={textDecoration}
            disabled={disabled}
            style={{ width: "32%", marginLeft: "2%", minWidth: 100 }}
            value={startValue}
            disabledDate={current =>
              this.getDisabledDate(current, this.state.endValue)
            }
            // disabledDate={current =>{ return this.state.endValue && current && current.getTime() >= (new Date(this.state.endValue).getTime()) }}
            format="yyyy-MM-dd"
            onChange={(a, b) => {
              let { selectValue, endValue = null } = this.state;
              this.setState({ startValue: b });
              this.props.onChange &&
                this.props.onChange([selectValue, b, endValue]);
            }}
          />
        )} */}
        {/* {selectValue === "6" && (
          <DatePicker
            textDecoration={textDecoration}
            disabled={disabled}
            style={{ width: "32%", marginLeft: "2%", minWidth: 100 }}
            value={endValue}
            disabledDate={current =>
              this.getDisabledDate(current, this.state.startValue, true)
            }
            // disabledDate={current =>{ return this.state.startValue && current && current.getTime() <= (new Date(this.state.startValue).getTime()) }}
            format="yyyy-MM-dd"
            onChange={(a, b) => {
              let { selectValue, startValue = null } = this.state;
              this.setState({ endValue: b });
              this.props.onChange &&
                this.props.onChange([selectValue, startValue, b]);
            }}
          />
        )} */}
      </div>
    );
  }
}

export default WeaDateGroup;



// WEBPACK FOOTER //
// ./ecology9/wea-date-group/index-mobx.js